import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MoTravelListPage } from '@/features/moTravel/pages/MoTravelListPage';
import { moTravelListSearchSchema } from '@/features/moTravel/types/moTravel.types';

export const Route = createFileRoute('/_auth/geo-location/mo-travel-history/')({
  validateSearch: moTravelListSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="MO Travel History">
      <Suspense fallback={<PageLoader />}>
        <MoTravelListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
